// EntityRef.Key — stable string encoding of an `EntityRef`.
//
// JS `Map<EntityRef, …>` uses object-reference equality, which is
// not what KB (or any downstream projection keyed on entity
// identity) wants. `entityRefKey` produces a deterministic string
// derived from `type`, `id`, and `version` (and — for
// `PartResourceRef` — the locator) so equal-in-content refs hash to
// the same key regardless of allocation, while distinct part
// selections on the same (id, version) key distinctly.
//
// Per `.docs/v1/design/surface.md` §4 and `bounded-contexts.md` §9
// (Slice 6) + §1 (Slice 7a). Encoding shape for the uniform
// `{ type; id; version }` variants:
//
//   `${type}:${id}:${version}`
//
// For `PartResourceRef` — which additionally carries `locator` — the
// encoding appends the locator segment:
//
//   `part_resource_ref:${id}:${version}:${locator}`
//
// Slice 7a widened `Resource.Ref` to a `whole_resource_ref |
// part_resource_ref` sum. Every other variant remains
// `{ type; id; version }`. Cross-BC utility — app-side projections
// and search indexes use `entityRefKey` rather than defining their
// own encoding, so KB state and app-side lookups line up.
export { entityRefKey };
// A claim node has no version (knowledge-bank.md §11.1): `claim_ref:${id}`,
// and a claim part appends its part: `claim_part_ref:${id}:${part}`.
const encode = (ref) => {
    switch (ref.type) {
        case "part_resource_ref":
            return `${ref.type}:${ref.id}:${ref.version}:${ref.locator}`;
        case "claim_ref":
            return `${ref.type}:${ref.id}`;
        case "claim_part_ref":
            return `${ref.type}:${ref.id}:${ref.part}`;
        default:
            return `${ref.type}:${ref.id}:${ref.version}`;
    }
};
const entityRefKey = (ref) => encode(ref);
//# sourceMappingURL=key.js.map